import React from "react";
import "./index.scss";

interface Props {
  children: React.ReactNode;
  duration?: number;
  className?: string;
}

const GenerateAnimation: React.FC<Props> = ({ children, duration, className }) => {
  return (
    <div className={`relative w-full ${className}`}>
      <div
        className="absolute left-0 bottom-0 w-full h-full bg-white z-[999] generate-animation-box"
        style={{ animationDuration: `${duration || 3}s` }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="1014"
          height="2"
          viewBox="0 0 1014 2"
          fill="none"
          className="absolute left-0 top-[20px] w-full"
        >
          <path
            d="M0 1H1014"
            stroke="url(#paint0_linear_238_793)"
            strokeWidth="2"
          />
          <defs>
            <linearGradient
              id="paint0_linear_238_793"
              x1="0"
              y1="1.5"
              x2="1014"
              y2="1.5"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#c4330a" stopOpacity="0" />
              <stop offset="0.5" stopColor="#c4330a" />
              <stop offset="1" stopColor="#c4330a" stopOpacity="0" />
            </linearGradient>
          </defs>
        </svg>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="1023"
          height="36"
          viewBox="0 0 1023 36"
          fill="none"
          className="absolute left-0 top-0 w-full"
        >
          <g filter="url(#filter0_f_238_794)">
            <path
              d="M17 18H1006"
              stroke="url(#paint0_linear_238_794)"
              strokeWidth="3"
            />
          </g>
          <defs>
            <filter
              id="filter0_f_238_794"
              x="0.700001"
              y="0.200001"
              width="1021.6"
              height="35.6"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="8.15"
                result="effect1_foregroundBlur_238_794"
              />
            </filter>
            <linearGradient
              id="paint0_linear_238_794"
              x1="17"
              y1="18.5"
              x2="1006"
              y2="18.5"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#c4330a" stopOpacity="0.1" />
              <stop offset="0.5" stopColor="#c4330a" />
              <stop offset="1" stopColor="#c4330a" stopOpacity="0.1" />
            </linearGradient>
          </defs>
        </svg>
      </div>
      {children}
    </div>
  );
};

export default GenerateAnimation;
